'use client'


export default function imageLoader({ src, width, quality }) {
  const params = new URLSearchParams({
    w: width.toString(),
    q: (quality || 75).toString()
  })

  return `${src}?${params}`;
}